import {
  createSemanticMetrics,
  createUniversalReporter,
  MetricTypes,
  Tags,
  Time,
} from '@spotify-internal/semantic-metrics';

const { sendMetric } = createSemanticMetrics({
  key: 'support-site-frontend',
  reporter: createUniversalReporter(),
  // Uncomment these two lines to send events locally, instantly
  // dev: false,
  // batching: false,
});

export { sendMetric };

export const sendCounterMetric = (what: string, tags?: Tags) => {
  sendMetric({
    metric_type: MetricTypes.COUNTER,
    what,
    value: 1,
    tags,
  });
};

export const sendPageview = (path: string, locale?: string) => {
  sendCounterMetric('pageview', { path, ...(locale && { locale }) });
};

export const sendTimerMetric = (what: string, value: number, tags?: Tags) => {
  sendMetric({
    metric_type: MetricTypes.TIMER,
    what,
    value: Time.fromMillis(value).asNanos(),
    tags,
  });
};
